// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserAvatars_container__p4wji {
  display: inline-flex;
}

.UserAvatars_el__LtTSN {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 16px;
}
.UserAvatars_el__avatar__4Gafp {
  position: relative;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
}
.UserAvatars_el__LtTSN:not(:first-child) {
  margin-left: -18px;
}
.UserAvatars_el__LtTSN .select-abr {
  position: static;
  width: 100%;
  height: 100%;
  min-width: unset;
  margin: 0;
  border-radius: inherit;
  transform: none;
}
.UserAvatars_el__total__aZ5wy {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--uas-count-fz, 12px);
  line-height: 1.3;
  color: #F9FAFB;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: inherit;
}

.UserAvatars_dropList__JOJzx {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 282px;
  padding: 4px;
  border-radius: 4px;
  background: #fff;
  font-size: var(--uas-fz, 14px);
  line-height: var(--uas-lh, 1);
  white-space: nowrap;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.08);
  z-index: 999999;
}
.UserAvatars_dropList__JOJzx .UserAvatars_el__LtTSN {
  margin: 0;
}

.UserAvatars_other__aVGf8 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 24px;
  padding: 4px;
  border-radius: 4px;
  background: #F9FAFB;
  color: #3D525C;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/UserAvatars/UserAvatars.module.scss"],"names":[],"mappings":"AACA;EACE,oBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AAAF;AAEE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAKI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AAHN;AAOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,sBAAA;AALJ;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,mBAAA;EACA,2CAAA;EACA,eAAA;AANF;AAQE;EACE,SAAA;AANJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;AAPF","sourcesContent":["\r\n.container {\r\n  display: inline-flex;\r\n}\r\n\r\n.el {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  line-height: 16px;\r\n\r\n  &__avatar {\r\n    position: relative;\r\n    flex-shrink: 0;\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 50%;\r\n    border: 2px solid #fff;\r\n  }\r\n\r\n  &:not(:first-child) {\r\n    margin-left: calc((28px - 10px) * -1);\r\n  }\r\n\r\n  :global {\r\n    .select-abr {\r\n      position: static;\r\n      width: 100%;\r\n      height: 100%;\r\n      min-width: unset;\r\n      margin: 0;\r\n      border-radius: inherit;\r\n      transform: none;\r\n    }\r\n  }\r\n\r\n  &__total {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: var(--uas-count-fz, 12px);\r\n    line-height: 1.3;\r\n    color: #F9FAFB;\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    border-radius: inherit;\r\n  }\r\n}\r\n\r\n.dropList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  max-width: 282px;\r\n  padding: 4px;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  font-size: var(--uas-fz, 14px);\r\n  line-height: var(--uas-lh, 1);\r\n  white-space: nowrap;\r\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.08);\r\n  z-index: 999999;\r\n\r\n  .el {\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.other {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  min-height: 24px;\r\n  padding: 4px;\r\n  border-radius: 4px;\r\n  background: #F9FAFB;\r\n  color: #3D525C;\r\n  text-transform: capitalize;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserAvatars_container__p4wji`,
	"el": `UserAvatars_el__LtTSN`,
	"el__avatar": `UserAvatars_el__avatar__4Gafp`,
	"el__total": `UserAvatars_el__total__aZ5wy`,
	"dropList": `UserAvatars_dropList__JOJzx`,
	"other": `UserAvatars_other__aVGf8`
};
export default ___CSS_LOADER_EXPORT___;
